import React, { Component } from 'react';
import {connect} from 'react-redux'
import {getJoke} from '../dbApi/DbApi'


class JokeBox extends Component {

  state = {
    joke: {
      content:""
    }
  }

    async componentDidMount(){
      try {
        console.log(`loading jock`);
        this.setState({
          joke: await getJoke(this.props.category)
        })
      } catch (e) {
        console.log("there was an error!");
        console.log(e);
      } finally {
      }
    }

  render() {
    return (
      <div className="text-muted joke">
        {this.state.joke.content}
      </div>
        );
  }
}

const mapStateToProps = (state) => ({
  category: state.optionQueryParams.category,
})

const actionsCreators = {
}

export default connect(mapStateToProps, actionsCreators)(JokeBox)
